import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const ROUTE_CONFIG = {
  '/signin': {
    title: 'Sign in to your Veeqo account',
    description: 'Log in to your Veeqo account to manage shipping and inventory for your multichannel orders'
  },
  '/signup': {
    title: 'Sign up for a free Veeqo account',
    description: 'Create a free account to manage shipping and inventory for your multichannel orders'
  },
  default: {
    title: 'Veeqo | One Software For All Your Ecommerce Fulfillment Needs',
    description: 'All in one ecommerce fulfilment software to manage your inventory, shipping and warehouse operations.'
  }
};

export const DynamicHead = () => {
  const location = useLocation();
  
  const getRouteConfig = () => {
    const matchedRoute = Object.keys(ROUTE_CONFIG).find(route => 
      location.pathname.includes(route)
    );
    
    return matchedRoute ? ROUTE_CONFIG[matchedRoute as keyof typeof ROUTE_CONFIG] : ROUTE_CONFIG.default;
  };

  const { title, description } = getRouteConfig();

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};
